import { isBoolean } from 'lodash';
import { useCallback, useMemo, useState } from 'react';

const useToggleDialog = (bool) => {
  const [open, setOpen] = useState(isBoolean(bool) ? bool : false);
  const [close, setClose] = useState(isBoolean(bool) ? bool : false);

  const clearModalOpen = useCallback(() => {
    setTimeout(() => {
      setClose((close) => !close);
      /**
       * Fix freeze bug - user cannot scroll
       */
      // Check if modal exist, remove class modal-open
      const noModalExist = document.querySelectorAll("body > div[tabindex='-1']")?.length === 0;
      if (noModalExist) {
        console.log('%cNo modal? =>> remove modal-open', 'color: green');
        document.body.classList.remove('modal-open');
      }
    }, 500);
  }, []);

  const toggle = useCallback(
    (bool) => {
      if (typeof bool === 'boolean') {
        setOpen(bool);
        clearModalOpen();
        return;
      }

      setOpen((open) => !open);
      clearModalOpen();
    },
    [clearModalOpen]
  );

  const shouldRender = useMemo(() => {
    return open || close;
  }, [open, close]);

  return [open, toggle, shouldRender];
};

export default useToggleDialog;
